type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'UnitType'
const nameSource = 'warehouse/unitTypes'
const namePageTitle = 'Unidades'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Unidades',
  to: '/warehouse/unitTypes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/warehouse/unitTypes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/warehouse/unitTypes/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Atualizar',
    to: '/warehouse/unitTypes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
